/**
 * The two numbers the dense table's geometry is built from.
 *
 * They live in their own module because four things need them and one of those
 * four is `DataTable.tsx` itself: `window.ts` computes a scroll extent from the
 * row height, `Skeleton.tsx` matches the real geometry with it, `table.css`
 * states it a second time (asserted equal by a test rather than trusted), and
 * the component renders it. A constant exported from the component would make
 * every one of those an edge into a React module, and `window.ts` importing
 * `DataTable.tsx` while `DataTable.tsx` imports `window.ts` is a cycle this
 * repo enforces against.
 *
 * `DataTable.tsx` re-exports {@link TABLE_ROW_HEIGHT} so its existing importers
 * did not have to move.
 */
/**
 * 47px, fixed — `components.md`'s dense-table row.
 *
 * **Fixed height is what lets virtualisation and skeletons agree.** A windowed
 * list computes which rows to render from a height it must know *before* it has
 * the rows, and a skeleton that is close but not equal produces a visible jump
 * on load — the jump that makes a fast page feel slow.
 */
export const TABLE_ROW_HEIGHT = 47;
/**
 * Rows rendered beyond each edge of the viewport.
 *
 * `components.md`: *"Windowed rendering, 12-row overscan."* The overscan is what
 * keeps a fast scroll from showing blank space before React has re-rendered, and
 * it is spent on both edges rather than in the scroll direction — a directional
 * overscan is faster on paper and wrong the moment the user scrolls back.
 */
export const TABLE_OVERSCAN_ROWS = 12;
//# sourceMappingURL=geometry.js.map